<template>
  <div class="productList">
    <div class="content">
      <div class="selectCrumb">
      <breadcrumb v-if='$i18n.locale=="en"' v-bind:path2="this.group"></breadcrumb>
      <breadcrumb v-if='$i18n.locale=="ch"' v-bind:path2="this.chgroup"></breadcrumb>
      <!--select order-->
      <div class="collection-header">
        <div class="filters-toolbar-wrapper">
          <div class="filters-toolbar__item-child">
            <p>{{ $t('sortBy') }} :</p>
            <el-select v-model="option" v-bind:placeholder="$t('pleaseSelectSortingMethod')" value="" @change="updateFilter">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <!--end select order-->
    </div>
    <!--子导航-->
    <!-- <div class="page-width">
      <div class="sonNav" v-if="sonNavList.length">
        <swiper class="hidden-md-and-up" :options="recommendedSwiper" ref="mySwiper" >
          <swiper-slide v-for="(item, index) in sonNavList" v-bind:key="index">
            <a style="max-width: 136px" @click="fetchSelectedCategories(item.ProductCategory_id)">{{item.Name}}</a>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev el-icon-caret-left hidden-md-and-up"></div>
        <div class="swiper-button-next el-icon-caret-right hidden-md-and-up"></div>
        <ul class="hidden-md-and-down">
          <li v-for="(item, index) in sonNavList" @click="fetchSelectedCategories(item.ProductCategory_id)" v-bind:key="index">
            <a v-if='$i18n.locale=="en"'>{{item.Name}}</a>
            <a v-if='$i18n.locale=="ch"'>{{item.Description}}</a>
          </li>
        </ul>
      </div>
    </div> -->
    <!--end子导航-->

    <!--特别促销-->
    <!--end特别促销-->

    

    <!--列表主题-->
    <div v-if="this.isLoadings" class="product-listing-container">
        <div class="loadmore disableBtn">
          <span>{{ $t('loadingProducts')}}</span>
          <i class="loading">
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
          </i>
        </div>
    </div>

    <div v-if="!this.isLoadings" class="product-listing-container">
        <ul>
          <li v-for="(item, index) in list" v-bind:key="index" v-if="!item.IsStopSale">
            <productCard v-if='$i18n.locale=="en"'
              v-bind:img="item.ThumbnailLarge"
              v-bind:link="item.link"
              v-bind:name="item.Name"
              v-bind:isPromotion="item.IsPromotion"
              v-bind:price="item.Price"
              v-bind:item="item"
              v-bind:inCart="inCart"
              v-bind:quantity="item.Quantity"
              v-bind:key="index"
              v-bind:group="item.group"
              v-bind:endTime="item.EndTime"
              v-bind:GroupedSaleLimit="item.GroupedSaleLimit"
              v-bind:GroupSoldQuantity="item.GroupSoldQuantity"
            ></productCard>
            <productCard v-if='$i18n.locale=="ch"'
              v-bind:img="item.ThumbnailLarge"
              v-bind:link="item.link"
              v-bind:name="item.Description"
              v-bind:isPromotion="item.IsPromotion"
              v-bind:price="item.Price"
              v-bind:item="item"
              v-bind:inCart="inCart"
              v-bind:quantity="item.Quantity"
              v-bind:key="index"
              v-bind:group="item.group"
              v-bind:endTime="item.EndTime"
              v-bind:GroupedSaleLimit="item.GroupedSaleLimit"
              v-bind:GroupSoldQuantity="item.GroupSoldQuantity"
            ></productCard>
          </li>
        </ul>
        <div class="loadmore disableBtn">
          <span>{{ $t('noMoreProducts')}}</span>
          <i class="loading">
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
          </i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from "@/components/breadcrumb";
import productCard from "./productCard";
import { mapActions, mapState, mapMutations } from 'vuex';
import {
  isUserAuthenticated,
  setLocalCart,
  getLocalCart,
  flyToElement
} from "../store/modules/cart";
export default {
  name: "productList",
  components: {
    breadcrumb,
    productCard
  },
  props: {
    isLoading: { type: Boolean },
    group: {
      type: String,
    },
    // chgroup: {
    //   type: String,
    // }
  },
  data() {
    return {
      chgroup: '',
      sonNavList: [],
      option:"",//下拉框选项值
      isLoadings:this.isLoading,
      //drop down
      options: [{
        value: '1',
        label: 'Alphabetically, A-Z'
      }, {
        value: '2',
        label: 'Alphabetically, Z-A'
      }, {
        value: '3',
        label: 'Price, low to high'
      },/*{
        value: '4',
        label: 'Index Number'
      }*/],
      recommendedSwiper: {
        slidesPerView: 5, // how many to shoe in a row
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        roundLengths : true,
        spaceBetween: 20,
        breakpoints: {
          320: {
              slidesPerView: 1,
          },
          //when width >= 480
          480:{
              slidesPerView: 2,
          },
          768: {
              slidesPerView: 4,
          },
          //when width >= 640
          990: {
              slidesPerView: 4,
          },
          1200:{
              slidesPerView: 4,
          },
          1280: {
              slidesPerView: 5,
          }
        }
      },
      list: [],
      listReg: [],
      listOut: [],
      catReg: [],
      catOut: [],
      inCart: null,
    }
  },
  methods: {
    ...mapActions('products',['fetchCategories', 'fetchProductsWithGroupId', 'fetchGroupBuyWithId', 'fetchWholesaleWithId']),
    ...mapMutations('products', ['updateActiveProduct']),
    ...mapActions('cart', ['addProductToCart']),
    ...mapMutations('checkout', ['setPricesForCheckout', 'saveTotalPrice', 'saveGrandTotal', 'clearPromoCode', 'clearCard']),
    isOutOfStock(item) {
      if(item.IsOverSaleable) {
        return false
      }
      return item.StockLevel > 0 ? false : true
    },
    updateFilter(value) {
      if(value === '1') {
        this.list = this.list.sort((a,b) => {
          return a.Name[0] > b.Name[0] ? 1 : -1;
        })
      }
      if(value === '2') {
        this.list = this.list.sort((a,b) => {
          return a.Name[0] < b.Name[0] ? 1 : -1;
        })
      }
      if(value === '3') {
        this.list = this.list.sort((a,b) => {
          return a.Price - b.Price;
        })
      }
      /*
      if(value === '4') {
        this.list = this.list.sort((a,b) => {
          return a.GeneralNum > b.GeneralNum ? 1 : -1;
        })
      }*/
    },
    fetchSelectedCategories(id) {
      this.fetchCategories(id)
      .then(res => {
        const ctemp1 = [];
        const ctemp2 = [];
        const sortedData = res.data.map((a)=>{
          if(this.isOutOfStock(a)) {
            ctemp2.push(a)
          }else {
            ctemp1.push(a)
          }
        }) 
        this.catOut = ctemp2.sort((a,b)=>{
          return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        });
        this.catReg = ctemp1.sort((a,b) => {
          return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        })
        this.list = this.catReg.concat(this.catOut);
      })
      .catch(err => {
        console.log('err fetching product', err);
      })
    },
    fetchSelectedGroup(id, type) {
      this.isLoadings = true;
      this.fetchProductsWithGroupId([id, type])
      .then(res => {
        this.isLoadings = false;
        //console.log('this is res.data', res.data);
        const temp1 = [];
        const temp2 = [];
        const sortedData = res.data.map((a)=>{
          if(this.isOutOfStock(a)) {
            temp2.push(a)
          }else {
            temp1.push(a)
          }
        }) 
        this.listOut = temp2.sort((a,b)=>{
          return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        });
        this.listReg = temp1.sort((a,b) => {
          return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        })
        this.list = this.listReg.concat(this.listOut);
        if(this.$route.params.group == 'group'){
          this.list.forEach(item=>{
            item.group = true
          })
        }
      })
      .catch(err => {
        this.isLoadings = false;
        console.log('err', err)
      })
    },

    fetchGroupBuy(id) {
      this.isLoadings = true;
      this.fetchGroupBuyWithId()
      .then(res => {
        this.isLoadings = false;
        // console.log('this is res', res.data.record);

        const temp1 = [];
        const sortedData = res.data.record.map((a)=>{
          // temp1.push({ IsOverSaleable: false, IsPromotion: true, 
            
          // });
          temp1.push({...a, group: true, Name: a.ProductName, IsPromotion: true, Product_id: a.Product, Price: a.ProductGroupPrice, OriginalPrice: a.RefPrice});
        })
        this.list = temp1;
        // const temp1 = [];
        // const temp2 = [];
        // const sortedData = res.data.map((a)=>{
        //   if(this.isOutOfStock(a)) {
        //     temp2.push(a)
        //   }else {
        //     temp1.push(a)
        //   }
        // }) 
        // this.listOut = temp2.sort((a,b)=>{
        //   return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        // });
        // this.listReg = temp1.sort((a,b) => {
        //   return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        // })
        // this.list = this.listReg.concat(this.listOut);
        
        // if(this.$route.params.group == 'group'){
        //   this.list.forEach(item=>{
        //     item.group = true
        //   })
        // }
       
      })
      .catch(err => {
        this.isLoadings = false;
        console.log('err', err)
      })
    },

    fetchWholesale(id) {
      this.isLoadings = true;
      this.fetchWholesaleWithId()
      .then(res => {
        this.isLoadings = false;
        // console.log('this is res', res.data.record);

        const temp1 = [];
        const sortedData = res.data.record.map((a)=>{
          // temp1.push({ IsOverSaleable: false, IsPromotion: true, 
            
          // });
          temp1.push({...a, EndTime: null, group: true, Name: a.ProductName, IsPromotion: true, Product_id: a.Product, Price: a.ProductGroupPrice, OriginalPrice: a.RefPrice});
        })
        this.list = temp1;
        // const temp1 = [];
        // const temp2 = [];
        // const sortedData = res.data.map((a)=>{
        //   if(this.isOutOfStock(a)) {
        //     temp2.push(a)
        //   }else {
        //     temp1.push(a)
        //   }
        // }) 
        // this.listOut = temp2.sort((a,b)=>{
        //   return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        // });
        // this.listReg = temp1.sort((a,b) => {
        //   return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        // })
        // this.list = this.listReg.concat(this.listOut);
        
        // if(this.$route.params.group == 'group'){
        //   this.list.forEach(item=>{
        //     item.group = true
        //   })
        // }
       
      })
      .catch(err => {
        this.isLoadings = false;
        console.log('err', err)
      })
    },

    handleAddToCartSuccess(item) {
      this.$store.dispatch('cart/addCart', item);
    },
    handleAddToCartFail() {
      alert('no enought product in stock');
    },
    addToCart: function(item, event) {
      if (isUserAuthenticated()) {
        this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item})
        .then(() => {
        flyToElement(event.target, $('.cart-link'));
        })
      } else {
        this.$store.dispatch('cart/addProductToLocalCart', item)
        flyToElement(event.target, $('.cart-link'));
      }
    },
    goToProductDetail(product) {
      this.updateActiveProduct(product.ProductNum);
      // this.$router.push({ name: 'productDetails', params: { productNum: product.ProductNum} })
      this.$router.push({ path: '/productDetails', query: { productNum: product.ProductNum}})
    },
  },
  beforeRouteLeave(to, from, next) {
    if (isUserAuthenticated() && to.name === 'purchase') {
      this.$store.dispatch('cart/getCart')
      .then(() => {
      const cartItems = {};
      cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
      cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
      cartItems.ShippingMethod = "Delivery";
      cartItems.Tip = 0;
      cartItems.TipPercentage = 0;
      cartItems.TotalPrice =  this.$store.state.cart.cartProductsList.TotalPrice;
      cartItems.IsShareCreditUsed = this.IsShareCreditUsed;
      this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
      .then(() => {
        this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
      })
      })
    }
    this.clearPromoCode();
    this.clearCard();
    next();
  },
  computed: mapState({
    allGroups: state => state.navbar.allGroups,
    activeCategory: state => state.products.activeCategory,
    activeProduct: state => state.products.activeProduct,
    product: state => state.products.productDetails[0],
    necessaryCartItems: state => state.cart.necessaryCartItems,
    itemCount: state => state.cart.itemCount,
    IsShareCreditUsed: (state) => state.checkout.IsShareCreditUsed,
  }),
  watch: {
    allGroups: function(newVal, oldVal) {
      if(this.$route.params.group == 'Group Buy'){
        this.fetchGroupBuy(1)
        return
      }
      if(this.$route.params.group == 'Wholesale'){
        this.fetchWholesale(1)
        return
      }
      const currentGroup = [];
      let currentGroupType = '';
      newVal.forEach(group => {
        if(this.group.toLowerCase() === group.Name.toLowerCase()){
          currentGroup.push(group);
          currentGroupType = 'group';
        }
        group.Categories.forEach(item=>{
          if(item.Name.toLowerCase() === this.group.toLowerCase()){
            currentGroup.push(item);
            currentGroupType = 'category';
          }
        })
      })
      // console.log('344',currentGroup,this.group)
      this.sonNavList = [];
      if(this.group.toLowerCase() === 'frozen') {
        this.sonNavList = currentGroup[0].Categories;
      }
       if (currentGroup.length>0 && currentGroupType === 'category') {
        this.chgroup = currentGroup[0].Description;
        this.fetchSelectedGroup(currentGroup[0].ProductCategory_id, 'category')
      }
        if (currentGroup.length>0 && currentGroupType === 'group') {
        this.chgroup = currentGroup[0].Description;
        this.fetchSelectedGroup(currentGroup[0].ProductGroup_id, 'group')
      }
    },
    // group: function(newVal, oldVal) {
    //   if(this.$route.params.group == 'groupbuy'){
    //     this.fetchGroupBuy(1)
    //     return
    //   }

    //   const currentGroup = []
    //   this.allGroups.forEach(group => {
    //     group.Categories.forEach(item=>{
    //       if(newVal === item.Name.toLowerCase()){
    //         currentGroup.push(item)
    //       }
    //     })
    //   })
    //   // console.log('357',currentGroup)

    //   if (currentGroup) {
    //     this.chgroup = currentGroup[0].Description;
    //   }
    //   this.sonNavList = [];
    //   this.option = '';
    //   if(this.group.toLowerCase() === 'frozen') {
    //     this.sonNavList = currentGroup[0].Categories;
    //   }
    //   this.fetchSelectedGroup(currentGroup[0].ProductCategory_id);
    // },
    $route(to, from) {
      const currentGroup = []
      let currentGroupType = '';
      if (to.path === "/collections/Group Buy") {
            this.fetchGroupBuy(1)
            return;
      } else if (to.path === "/collections/Wholesale") {
        this.fetchWholesale(1)
        return;
        } else if (to.name === "productList") {
              this.allGroups.forEach(group => {
                if(this.group === group.Name.toLowerCase()){
                  currentGroup.push(group);
                  currentGroupType = 'group';
                }
                group.Categories.forEach(item=>{
                  if(this.group === item.Name.toLowerCase()){
                    currentGroup.push(item);
                    currentGroupType = 'category';
                  }
                })
              })

            if (currentGroup.length>0 && currentGroupType === 'category') {
              this.chgroup = currentGroup[0].Description;
              this.fetchSelectedGroup(currentGroup[0].ProductCategory_id, 'category')
            }
             if (currentGroup.length>0 && currentGroupType === 'group') {
              this.chgroup = currentGroup[0].Description;
              this.fetchSelectedGroup(currentGroup[0].ProductGroup_id, 'group')
            }
      }
    }
  },
  mounted: function() {
    if(this.$route.params.group == 'Group Buy'){
      this.chgroup = '团购';
      this.fetchGroupBuy(1)
      return
    } 
     if(this.$route.params.group == 'Wholesale'){
      this.chgroup = '批发';
      this.fetchWholesale(1)
      return
    } 
    
    this.$root.fetchSelectedGroup = this.fetchSelectedGroup.bind(this);

    let currentGroupType = '';
    const currentGroup = []
      this.allGroups.forEach(group => {
        if(this.group === group.Name.toLowerCase()){
          currentGroup.push(group);
          currentGroupType = 'group';
        }
        group.Categories.forEach(item=>{
          if(this.group === item.Name.toLowerCase()){
            currentGroup.push(item);
            currentGroupType = 'category';
          }
        })
      })

    console.log('375',currentGroup)

    if (currentGroup.length>0 && currentGroupType === 'category') {
      this.chgroup = currentGroup[0].Description;
      this.fetchSelectedGroup(currentGroup[0].ProductCategory_id, 'category');
    }
    if (currentGroup.length>0 && currentGroupType === 'group') {
      this.chgroup = currentGroup[0].Description;
      this.fetchSelectedGroup(currentGroup[0].ProductGroup_id, 'group');
    }
    // this.sonNavList = [];
    if(this.group.toLowerCase() === 'frozen') {
      this.sonNavList = currentGroup[0].Categories;
    }

  }
}
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/productList.less";
</style>



// WEBPACK FOOTER //
// src/view/productList.vue